module.exports = __webpack_public_path__ + "img/tiktok-icon.89c61c3e.svg";